import { Component, OnInit } from '@angular/core';
import { AppInformationService, GenesisUnitOfWork } from 'app/core/core.module';
import { SalesRep } from 'app/core/model/entity-model';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-sales-rep-dialog',
    templateUrl: './sales-rep-dialog.component.html',
    styleUrls: ['./sales-rep-dialog.component.scss'],
    standalone: false
})
export class SalesRepDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    salesRep: SalesRep;
    displayOrder: number;
    validationGroup: 'salesRepValidationGroup';

    constructor(
        public modalRef: BsModalRef,
        private uow: GenesisUnitOfWork,
        private appInfo: AppInformationService
    ) {}

    async ngOnInit() {

        await this.getData();
    }

    async getData() {
        if (!this.salesRep){
            this.salesRep = this.uow.salesReps.createEntity({
                created: new Date(),
                displayOrder: this.displayOrder
            }) as SalesRep;
        }
    }

    async save() {
        if (!this.validate()) return;
        this.result.next({ success: true });
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig('salesRepValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('salesRepValidationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
